export class Tag{
    title: string;
    id:number;
    type: string;    // (i.e., simple, complex) // use ngSwitch in template: https://angular.io/docs/ts/latest/api/common/index/NgSwitch-directive.html
    selected: boolean = false;
    category: string;
    image: string;
    description: string;
    tooltip: string;
    tooltipOpen: boolean = false;
    expanded: boolean = false;
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/models/tag.model.ts